import { render, staticRenderFns } from "./ResultPay.vue?vue&type=template&id=717e7311&"
import script from "./ResultPay.vue?vue&type=script&lang=js&"
export * from "./ResultPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports